
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
 name:"klyr",
 components: {
   CommonTitle,
   BannerTop,
   // Notice
 },
 computed: {
  contentList () {
      return this.$t('news.klyr.contentList')
    },
 },
 data() {
  return {
    bannerUrl:require("~/static/images/news/banner.png"),
    imageList: [
      {
        id: 1,
        src: require(`@/static/images/news/klyr/1.png`)
      },
      {
        id: 2,
        src: require(`@/static/images/news/klyr/2.png`)
      },
      {
        id: 3,
        src: require(`@/static/images/news/klyr/3.png`)
      },
      {
        id: 4,
        src: require(`@/static/images/news/klyr/4.png`)
      },
      {
        id: 5,
        src: require(`@/static/images/news/klyr/5.png`)
      },
      {
        id: 6,
        src: require(`@/static/images/news/klyr/6.png`)
      },
      {
        id: 7,
        src: require(`@/static/images/news/klyr/7.png`)
      }
    ],
  }
 },
}
